import CloseIcon from "@mui/icons-material/Close";
import { TimeTypeSelect } from "../components/Selects";
import { DateTimeInput, TimeInput } from "../components/Inputs";
import { CreateTableItinerary } from "../components";

export function ViewChangeLogRequestForm({
	isOpen,
	onClose,
	employeePersonalInformationFullNameChangeLogRequest,
	timeTypeChangeLogRequest,
	dateChangeLogRequest,
	timeRequestedChangeLogRequest,
	reasonChangeLogRequest,
	setTimeTypeChangeLogRequest,
	setDateChangeLogRequest,
	setTimeRequestedChangeLogRequest,
	files,
	setFiles,
	data,
	viewImage,
}) {
	var header = ["Time In", "Time Out", "Location"];
	var accessor = ["timeIn", "timeOut", "location"];

	const handleClose = () => {
		onClose();
	};

	return (
		<>
			<div className={`modal-overlay ${isOpen ? "open" : ""}`}>
				{isOpen && (
					<div className="modal">
						<div className="popUp-header row">
							<div className="popUp-title">
								<h3 style={{ color: "#668fca" }}>Request Details</h3>
							</div>
							<div className="popUp-close">
								<CloseIcon onClick={() => handleClose()} />
							</div>
						</div>
						<div className="popUp-body">
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">Employee</div>
									<div className="info-item-input">
										<input
											readOnly={true}
											id="employeePersonalInformationFullNameChangeSchedule"
											placeholder="Employee"
											value={
												employeePersonalInformationFullNameChangeLogRequest
											}
										/>
									</div>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">Time Type</div>
									<div className="info-item-input">
										<TimeTypeSelect
											timeType={timeTypeChangeLogRequest}
											setTimeType={setTimeTypeChangeLogRequest}
											isView={true}
										/>
									</div>
								</div>
							</div>
							<div className="info-item-holder row">
								<div className="popUp-item info-item column">
									<div className="info-item-label">Date</div>
									<div className="info-item-input">
										<DateTimeInput date={dateChangeLogRequest} setDate={setDateChangeLogRequest} isView={true} />
									</div>
								</div>
								<div className="popUp-item info-item column">
									<div className="info-item-label">Time Requested</div>
									<div className="info-item-input">
										<TimeInput
											date={timeRequestedChangeLogRequest}
											setDate={setTimeRequestedChangeLogRequest}
											isView={true}
										/>
									</div>
								</div>
							</div>
							<div className="popUp-item info-item column">
								<div className="info-item-label">Reason</div>
								<div className="info-item-input">
									<textarea
										id="tamper"
										className="filterSelect"
										style={{
											width: "90%",
											minHeight: "50px",
											borderRadius: "3px",
											border: "1px solid #80808080",
											color: "rgb(104, 104, 104)",
										}}
										value={reasonChangeLogRequest}
										readOnly
									/>
								</div>
							</div>
							<div className="popUp-item info-item column">
								<div className="info-item-label">Upload</div>
								<div className="info-item-input">
									{files.length > 0 && (
										<div
											style={{ border: "1px solid #97979745", padding: "10px" }}
										>
											<span>Uploaded File:</span>
											<ul>
												{files.map((file, index) => (
													<img
														src={file ? URL.createObjectURL(file) : ""}
														alt=""
														style={{ width: "150px", height: "auto" }}
													></img>
												))}
											</ul>
										</div>
									)}
								</div>
							</div>
							<div className="popUp-item info-item column">
								<div className="info-item-label">Itinerary</div>
								<div className="info-item-input">
									<div
										className="users-table container"
										style={{ overflow: "unset" }}
									>
										<CreateTableItinerary
											dataList={data}
											dataHeader={header}
											dataAccessor={accessor}
										/>
									</div>
									{data && data.length > 0 ? (
										<div></div>
									) : (
										<div
											style={{
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
											}}
										>
											{" "}
											{/*<p>No records to display</p>*/}
										</div>
									)}
								</div>
							</div>
						</div>
						<div
							className="buttons row"
							style={{ justifyContent: "end", padding: "20px 40px" }}
						>
							<button
								id="add-family"
								className="cancel row"
								style={{ height: "34px", borderRadius: "3px" }}
								onClick={handleClose}
							>
								Close
							</button>
						</div>
					</div>
				)}
			</div>
		</>
	);
}